import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceAccordionRenderComponent } from './render/slice-accordion-render.component';


export const sliceAccordionRenderModuleEntryComponents = [
  SliceAccordionRenderComponent,
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
  ],
  exports: [
    sliceAccordionRenderModuleEntryComponents
  ],
  declarations: sliceAccordionRenderModuleEntryComponents
})
export class SliceAccordionRenderModule {}

export default sliceAccordionRenderModuleEntryComponents;
